import Vue from 'vue'

import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../styles/custom.scss'//must be after the bootstrap includes
// import '../styles/styles.css'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)